export default {
  toolbar:
    [
      {
        name: 'clipboard',
        items: ['Cut', 'Copy', 'Paste', 'PasteText', 'MediaEmbed', 'PasteFromWord', '-', 'Undo', 'Redo']
      },
      {
        name: 'editing',
        items: ['Find', 'Replace', '-', 'SelectAll']
      },
      {
        name: 'tools',
        items: ['Maximize', '-', 'About']
      },
      {
        name: 'document',
        items: ['Source']
      },
      '/',
      {
        name: 'paragraph',
        items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv',
          '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
      },
      {
        name: 'links',
        items: ['Link', 'Unlink', 'Anchor']
      },
      {
        name: 'insert',
        items: ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'Iframe']
      },
      '/',
      {
        name: 'basicstyles',
        items: [
          'Bold',
          'Italic',
          'Underline',
          'Strike',
          'Subscript',
          'Superscript',
          '-',
          'CopyFormatting',
          'RemoveFormat'
        ]
      },
      {
        name: 'styles',
        items: ['Styles', 'Format', 'Font']
      }
    ],
  extraPlugins: 'mediaembed,find,selectall,div,justify,smiley,specialchar,iframe,font,colorbutton',
  extraAllowedContent: 'iframe[fullscreen,allowfullscreen]',
  removedButtons: '',
};



// WEBPACK FOOTER //
// ./src/data/CKEditor.js